var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var PluginState;
(function (PluginState) {
    PluginState["Enabled"] = "enabled";
    PluginState["Disabled"] = "disabled";
})(PluginState || (PluginState = {}));
export var Compatibility;
(function (Compatibility) {
    Compatibility["Compatible"] = "compatible";
    Compatibility["Incompatible"] = "incompatible";
})(Compatibility || (Compatibility = {}));
/** Stable gateway error codes, independent of the message language. */
export var PluginErrorCode;
(function (PluginErrorCode) {
    PluginErrorCode["Forbidden"] = "plugin-forbidden";
    PluginErrorCode["Disabled"] = "plugin-disabled";
    PluginErrorCode["Incompatible"] = "plugin-incompatible";
    PluginErrorCode["NotFound"] = "plugin-not-found";
    PluginErrorCode["Conflict"] = "plugin-conflict";
    PluginErrorCode["StateConflict"] = "plugin-state-conflict";
    PluginErrorCode["InvalidInput"] = "plugin-invalid-input";
    PluginErrorCode["Unavailable"] = "plugin-unavailable";
})(PluginErrorCode || (PluginErrorCode = {}));
var PluginRequestError = /** @class */ (function (_super) {
    __extends(PluginRequestError, _super);
    function PluginRequestError(message, code, current) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.current = current;
        Object.setPrototypeOf(_this, PluginRequestError.prototype);
        return _this;
    }
    return PluginRequestError;
}(Error));
export { PluginRequestError };
export var errorMessage = function (error) {
    return error instanceof Error ? error.message : String(error);
};
